// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3hJfy","inner":"Footer_inner__1IyjY","nextIcon":"Footer_nextIcon__f4vhT","innerLeft":"Footer_innerLeft__eb2Lq"};